export default __webpack_public_path__ + "static/media/vae8.750d2809.png";